require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/core-js/modules/es7.symbol.observable.js
// module id = 667
// module chunks = 8